import { checkAuthentication } from './middleware';
export const groupRoutes = [
    {
        path: '/groups',
        name: 'GroupList',
        component:  () => import(/* webpackChunkName: "group-route" */ '../views/groups/GroupList'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/groups/:id',
        name: 'ViewGroup',
        component: () => import(/* webpackChunkName: "group-route" */ '../views/groups/ViewGroup'),
        props: true,
        beforeEnter: checkAuthentication
    }

]